import React from 'react';
import VmsRedirect from 'src/components/vms-redirect';

const Timesheet: React.FC = () => <VmsRedirect />;

export default Timesheet;
